/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_GeneratingInputs */

const en_us2_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building your plan…`)
};

const pt_br2_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montando seu plano…`)
};

const es_419_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armando tu plan…`)
};

const pt_pt2_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A criar o teu plano…`)
};

const fr_fr2_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création de ton programme…`)
};

const de_de2_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan wird erstellt…`)
};

const it_it2_draft_generating = /** @type {(inputs: Draft_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sto creando la tua scheda…`)
};

/**
* | output |
* | --- |
* | "Building your plan…" |
*
* @param {Draft_GeneratingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_generating = /** @type {((inputs?: Draft_GeneratingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_GeneratingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_generating(inputs)
	if (locale === "es-419") return es_419_draft_generating(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_generating(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_generating(inputs)
	if (locale === "de-DE") return de_de2_draft_generating(inputs)
	if (locale === "it-IT") return it_it2_draft_generating(inputs)
	return en_us2_draft_generating(inputs)
});
export { draft_generating as "draft.generating" }